import React, { useState } from 'react';
import {
  Col,
  Row,
  VertButton,
  VertCheckboxImage,
  VertSearch,
} from '@vertem-core/vertice-ds';
import {useMediaQuery} from 'react-responsive';
import PropTypes from 'prop-types';

import {useSelector} from "react-redux";

const OptionsStores = ({ stores, maxItemsToShow = 8 }) => {
  const [visibleItems, setVisibleItems] = useState(maxItemsToShow);

  const showMoreItems = () => {
    setVisibleItems(visibleItems + maxItemsToShow);
  };

  const optionsStores = stores
    .slice(0, visibleItems)
    .map((item) => {
      return (
        <Col span={6} verticalSpacing="extra-small">
          <VertCheckboxImage {...item} className="filter-store" />
        </Col>
      );
    });
  return (
    <>
      { optionsStores }
      {stores.length > visibleItems && (
      <VertButton type="link" size="small" className="color-detached padding-x-none" onClick={showMoreItems}>
        Mostrar mais
      </VertButton>
      )}
    </>
  );
};

OptionsStores.propTypes = {
  stores: PropTypes.array.isRequired,
  maxItemsToShow: PropTypes.number,
};

const SearchTopFilter = ({ className, onSearch }) => {
  const Store = useSelector(({ Stores }) => Stores)
  const isMobile = useMediaQuery({ maxWidth: "768px" })
  // const Navigate = useNavigate()
  const [ searchText, setSearchText ] = useState('')
  if (!Store.ecommerce.length) return;
  return (
    <>
      {/*</MediaQuery>*/}
        <Col span={24} className="padding-bottom-regular">
          <Row gutter={24} justify="start" align="middle" className="vert-box-filter vert-box-filter vert-box-filter-title">
            <Col span={isMobile ? 24: 8}>
              <VertSearch
                placeholder="O que você está buscando?"
                value={searchText}
                onChange={({ target }) => {
                  setSearchText(target.value)
                }}
                onButtonHandler={() => {
                  onSearch(searchText)
                }}
              />

              {searchText && (
                  <VertButton
                      type='link'
                      className={'padding-x-none padding-y-none'}
                      onClick={() => {
                        setSearchText('')
                        onSearch('')
                      }}
                  >
                    Limpar filtro
                  </VertButton>
              )}
            </Col>
          </Row>
        </Col>
    </>
  );
};

SearchTopFilter.propTypes = {
  className: PropTypes.string,
};

export default SearchTopFilter;
